module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Warlord’s Bride")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc01"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Also by"), _c('br'), _vm._v("\nMARGARET MOORE")])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Knave’s Honor")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Notorious Knight")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("My Lord’s Desire")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hers To Desire")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hers To Command")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Unwilling Bride")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lord of Dunkeathe")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Bride of Lochbarr")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-505d4fc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warlordsbridethe_adc01.vue
// module id = 66
// module chunks = 0